import { Input } from '@deity-io/portal-ui';
import type { FC } from 'react';
import { useEffect, useState } from 'react';

interface IHostProps {
  isEditable: boolean;
  protocol: string;
  host?: string;
  onChange: (path: string[], val: string) => void;
}
export const Host: FC<IHostProps> = ({ isEditable, protocol, host, onChange }) => {
  const [val, setVal] = useState<string>();

  useEffect(() => {
    setVal(host);
  }, [host]);

  return (
    <Input
      label="Host"
      type="text"
      name="host"
      id="host"
      value={host || null}
      onChange={e => onChange(['host'], e.target.value)}
      placeholder="api.example.com"
      disabled={!isEditable}
      sx={{ marginY: 2 }}
      autoComplete="off"
    />
  );
};
